function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { Form, Rate } from 'antd';
import classNames from 'classnames';
import { Button, Input, Textarea } from "./..";
import React, { useState } from 'react';
import { useDeepCompareEffect } from 'ahooks';
import Tags from "./components/Tags";
import "./index.less";
export var SurveyForm = function SurveyForm(props) {
  var className = props.className,
    formData = props.formData,
    textData = props.textData,
    onRateNumChange = props.onRateNumChange,
    onSubmitSurveyForm = props.onSubmitSurveyForm,
    _props$rateProps = props.rateProps,
    rateProps = _props$rateProps === void 0 ? {
      count: 5,
      allowClear: false
    } : _props$rateProps;
  var classes = classNames('iron-survey', className);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    resetKey = _useState2[0],
    setResetKey = _useState2[1];
  var _useState3 = useState(formData.rateNum),
    _useState4 = _slicedToArray(_useState3, 2),
    rate = _useState4[0],
    setRate = _useState4[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  useDeepCompareEffect(function () {
    var checkOption = formData.surveyOptions.filter(function (item) {
      return item.isCheck;
    });
    form.setFieldsValue({
      rate: formData.rateNum,
      surveyOption: checkOption.length > 0 ? JSON.stringify(checkOption) : undefined,
      remark: formData.surveyRemark
    });
    setResetKey(Date.now());
  }, [formData]); // 这里传入深层依赖项数组或对象
  // useEffect(() => {
  //   const checkOption = formData.surveyOptions.filter((item) => item.isCheck);
  //   form.setFieldsValue({
  //     rate: formData.rateNum,
  //     surveyOption:
  //       checkOption.length > 0 ? JSON.stringify(checkOption) : undefined,
  //     remark: formData.surveyRemark,
  //   });
  // }, [JSON.stringify(formData)]);

  var onRatechange = function onRatechange(num) {
    if (rate === num) {
      return;
    }
    // rate 改变后,重新设置选中值
    form.resetFields();
    form.setFieldsValue({
      rate: num
    });
    onRateNumChange(num);
    setRate(num);
  };
  var onSubmit = function onSubmit() {
    try {
      form.validateFields().then(function (val) {
        onSubmitSurveyForm(_objectSpread(_objectSpread({}, val), {}, {
          surveyOption: val['surveyOption'] ? JSON.parse(val['surveyOption']) : val['surveyOption']
        }));
      });
    } catch (error) {
      console.error(error);
    }
  };
  var onTagsSelect = function onTagsSelect(val) {
    form.setFieldsValue({
      surveyOption: val.length === 0 ? '' : JSON.stringify(val)
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, /*#__PURE__*/React.createElement("div", {
    className: "iron-question-title"
  }, textData === null || textData === void 0 ? void 0 : textData.title), /*#__PURE__*/React.createElement("div", {
    className: "iron-question-subtitle"
  }, textData === null || textData === void 0 ? void 0 : textData.subTitle), /*#__PURE__*/React.createElement(Form, {
    name: "surveyForm",
    onFinish: onSubmit,
    autoComplete: "off",
    form: form,
    className: "iron-survey-form"
  }, /*#__PURE__*/React.createElement(Form.Item, {
    label: "",
    name: "rate",
    className: "iron-rate-form",
    rules: formData === null || formData === void 0 ? void 0 : formData.rules.filter(function (o) {
      return o.name === 'rate';
    })
  }, /*#__PURE__*/React.createElement(Rate, _extends({}, rateProps, {
    onChange: onRatechange,
    className: "iron-rate-container"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "iron-rate-tips"
  }, textData === null || textData === void 0 ? void 0 : textData.surveyRateTips), /*#__PURE__*/React.createElement("div", {
    className: "iron-suggestion-title"
  }, textData === null || textData === void 0 ? void 0 : textData.surveyOptionTitle), /*#__PURE__*/React.createElement(Form.Item, {
    label: "",
    name: "surveyOption",
    rules: formData.rules.filter(function (o) {
      return o.name === 'surveyOption';
    }),
    className: "iron-surveyOption-style"
  }, /*#__PURE__*/React.createElement(Input, {
    type: "hidden"
  })), /*#__PURE__*/React.createElement(Tags, {
    tagsData: formData === null || formData === void 0 ? void 0 : formData.surveyOptions,
    onSelectTag: onTagsSelect,
    resetKey: resetKey
  }), /*#__PURE__*/React.createElement("div", {
    className: "iron-suggestion-text-title"
  }, textData === null || textData === void 0 ? void 0 : textData.surveyRemarkTitle), /*#__PURE__*/React.createElement("div", {
    className: "iron-suggestion-text-wrapper"
  }, /*#__PURE__*/React.createElement(Form.Item, {
    label: "",
    name: "remark",
    className: "iron-rate-form",
    rules: formData.rules.filter(function (o) {
      return o.name === 'remark';
    })
  }, /*#__PURE__*/React.createElement(Textarea, {
    placeholder: textData === null || textData === void 0 ? void 0 : textData.textAreaPlaceholder,
    className: "iron-suggestion-textarea",
    maxLength: (formData === null || formData === void 0 ? void 0 : formData.remarkMax) || 200,
    autoSize: {
      minRows: 4,
      maxRows: 4
    },
    count: {
      show: true
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "iron-suggestion-submit"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    htmlType: "submit"
  }, textData === null || textData === void 0 ? void 0 : textData.submitText))));
};
export default SurveyForm;